import { Box } from '@material-ui/core';

export default function EnableDisableBox({ disabled, children, style, ...rest }) {
    const isDisabled = Boolean(disabled);
    const mergedStyle = {
        pointerEvents: isDisabled ? 'none' : 'auto',
        opacity: isDisabled ? 0.5 : 1,
        ...(style || {}),
    };

    return (
        <Box aria-disabled={isDisabled} style={mergedStyle} {...rest}>
            {children}
        </Box>
    );
}
